import { FormDisableDefaultBehavior } from '@/exceptions/FormDisableDefaultBehavior';
import { events } from '@/services/events';
import { SectionModelType } from '@/typings/types/types';

export class FormSubmitEvent extends CustomEvent<SectionModelType> {
  public static async emit(pageModel: SectionModelType): Promise<FormSubmitEvent> {
    const event = new FormSubmitEvent('submitForm', {
      detail: pageModel,
      cancelable: true
    });

    events.emit('formSubmit', event);

    if (event.defaultPrevented) {
      throw new FormDisableDefaultBehavior(
        'Prevent default behavior for form submit, was prevented in formSubmit SDK event'
      );
    }

    return event;
  }
}
